import { allAbTests } from '@daymade/common-lib/abTests';

/**
 * 1. The structure of each header state:
 *    - drawCounter: boolean
 *    - upNext: string or null
 *    - orderSummary: boolean
 */
export interface HeaderState {
  showDrawCounter: boolean;
  showUpNext: string | null;
  showOrderSummary: boolean;
}

/** 2. TestGroup types you support */
export type TestGroup = 'CONTROL' | 'TEST' | 'TEST_WITH_BOOST';

/**
 * 3. List of valid paths as literal types.
 *    These must match your config keys exactly.
 */
export type KnownPath =
  | '/choose-your-plan'
  | '/enternow/1'
  | '/enternow/3'
  | '/enternow/4'
  | '/enternow/5'
  | '/checkout';

/**
 * 4. A typed object that maps each KnownPath
 *    to a record of (CONTROL | TEST) => HeaderState
 */
const KNOWN_HEADER_CONFIG: Record<KnownPath, Record<TestGroup, HeaderState>> = {
  '/choose-your-plan': {
    CONTROL: {
      showDrawCounter: true,
      showUpNext: null,
      showOrderSummary: false,
    },
    TEST: {
      showDrawCounter: false,
      showUpNext: null,
      showOrderSummary: false,
    },
    TEST_WITH_BOOST: {
      showDrawCounter: false,
      showUpNext: null,
      showOrderSummary: false,
    },
  },
  '/enternow/1': {
    CONTROL: {
      showDrawCounter: true,
      showUpNext: null,
      showOrderSummary: false,
    },
    TEST: {
      showDrawCounter: false,
      showUpNext: 'Draw days',
      showOrderSummary: false,
    },
    TEST_WITH_BOOST: {
      showDrawCounter: false,
      showUpNext: 'Draw days',
      showOrderSummary: false,
    },
  },
  '/enternow/3': {
    CONTROL: {
      showDrawCounter: true,
      showUpNext: null,
      showOrderSummary: false,
    },
    TEST: {
      showDrawCounter: false,
      showUpNext: 'Boost',
      showOrderSummary: false,
    },
    TEST_WITH_BOOST: {
      showDrawCounter: false,
      showUpNext: 'Sign up',
      showOrderSummary: false,
    },
  },
  '/enternow/4': {
    CONTROL: {
      showDrawCounter: true,
      showUpNext: null,
      showOrderSummary: false,
    },
    TEST: {
      showDrawCounter: false,
      showUpNext: 'Sign up',
      showOrderSummary: false,
    },
    TEST_WITH_BOOST: {
      showDrawCounter: false,
      showUpNext: 'Sign up',
      showOrderSummary: false,
    },
  },
  '/enternow/5': {
    CONTROL: {
      showDrawCounter: false,
      showUpNext: null,
      showOrderSummary: false,
    },
    TEST: {
      showDrawCounter: false,
      showUpNext: 'Payment',
      showOrderSummary: false,
    },
    TEST_WITH_BOOST: {
      showDrawCounter: false,
      showUpNext: 'Payment',
      showOrderSummary: false,
    },
  },
  '/checkout': {
    CONTROL: {
      showDrawCounter: false,
      showUpNext: null,
      showOrderSummary: true,
    },
    TEST: {
      showDrawCounter: false,
      showUpNext: null,
      showOrderSummary: true,
    },
    TEST_WITH_BOOST: {
      showDrawCounter: false,
      showUpNext: null,
      showOrderSummary: true,
    },
  },
};

export function getHeaderContent(
  path: string,
  testGroup: string,
  boostTestGroup: string,
): HeaderState {
  // check only path not query params
  if (path.includes('?')) {
    path = path.split('?')[0];
  }

  const groupKey: TestGroup =
    boostTestGroup === allAbTests.ChooseYourPlanBoost[1].choice
      ? 'TEST_WITH_BOOST'
      : testGroup == 'CONTROL'
        ? 'CONTROL'
        : 'TEST';

  if (path in KNOWN_HEADER_CONFIG) {
    return KNOWN_HEADER_CONFIG[path as KnownPath][groupKey];
  }

  return {
    showDrawCounter: false,
    showUpNext: null,
    showOrderSummary: false,
  };
}
